import {
  FormGroup,
  FormControlLabel,
  Switch as SwitchMUI,
  FormControl,
  FormHelperText,
} from '@mui/material';

import type { TNameType } from '../../types/components/components.type';
import type { TSwitchProps } from './switch.type';

export const Switch = <TName extends TNameType>({
  handleChange,
  value,
  errorMessage,
  helperText,
  name,
  label,
  disabled = false,
  className = '',
}: TSwitchProps<TName>) => {
  const isError = !!errorMessage;

  return (
    <FormControl
      component="fieldset"
      variant="standard"
      id={name}
      name={name}
      error={isError}
      className={className}
    >
      <FormGroup>
        <FormControlLabel
          disabled={disabled}
          onChange={() => handleChange({ key: name, value: !value })}
          control={<SwitchMUI checked={value} />}
          label={label}
        />
      </FormGroup>

      {(isError || helperText) && (
        <FormHelperText>{isError ? errorMessage : helperText}</FormHelperText>
      )}
    </FormControl>
  );
};
